module.exports = __webpack_public_path__ + "img/send_white_48dp.4356e8e4.svg";